import { SELECIONAR_CONFIGURACAO_PONTO } from '../../actions/types'

const initialState = null
const estadoInicial = {
    id: null,
    empresa: {},
    quantidadePonto: null,
    habilitadoGeracaoPontos: null,
    habilitadoConsumoPontos: null,
    peso: null
}

export default function reducerAdesaoPontoSelecionado (state = estadoInicial, action = initialState) {
  switch (action.type) {
    case SELECIONAR_CONFIGURACAO_PONTO: {
      if (action.payload == null) {
        return estadoInicial;
      }
      return action.payload;
    }

    default: {
      return state
    }
  }
}